module.exports = __webpack_public_path__ + "img/q.1c6b5f3e.svg";